export const PAGE_SIZES: number[] = [5, 10, 20, 50, 100];

// this value should come from the server in order to have proper pagination.
// right now it is an arbitrary high amount so that users can navigate between pages.
export const GRID_TOTAL_AMOUNT = 10000;

export const COLUMNS_KEYS_TO_IGNORE = [
  "checkbox_selection",
  "action",
  "downtime",
  "repair_costs",
  "geo_location",
];

export const ARCHETYPE_GRID_OPTIONS = {
  risk_class_one: false,
  risk_class_two: false,
};

export const EMPTY_CELL_VALUE = "-";
